/**
 * Do not edit directly
 * Generated on Thu, 29 May 2025 08:34:47 GMT
 * Made with ❤️ by the METRO Design System team.
 */

module.exports = {
  mdsCoreBorderWidthBase: '0',
  mdsCoreBorderWidthThin: '1px',
  mdsCoreBorderWidthMedium: '2px',
  mdsCoreBorderWidthThick: '4px',
  mdsCoreBorderRadiusNone: '0',
  mdsCoreBorderRadiusBase: '2px',
  mdsCoreBorderRadiusMedium: '4px',
  mdsCoreBorderRadiusLarge: '8px',
  mdsCoreBorderRadiusXlarge: '16px',
  mdsCoreBorderRadiusCircle: '50%',
  mdsCoreColorBlueBase: 'hsl(216deg, 100%, 44%)',
  mdsCoreColorBlueFaded90: 'hsl(216deg, 30%, 92%)',
  mdsCoreColorBlueFaded70: 'hsl(216deg, 28%, 69%)',
  mdsCoreColorBlueFaded50: 'hsl(216deg, 47%, 38%)',
  mdsCoreColorBlueFaded10: 'hsl(216deg, 100%, 13%)',
  mdsCoreColorBlueShade20: 'hsl(216deg, 100%, 35%)',
  mdsCoreColorBlueTint10: 'hsl(216deg, 78%, 50%)',
  mdsCoreColorBlueTint20: 'hsl(216deg, 78%, 55%)',
  mdsCoreColorBlueTint40: 'hsl(216deg, 78%, 66%)',
  mdsCoreColorBlueTint80: 'hsl(216deg, 78%, 89%)',
  mdsCoreColorBlueTint90: 'hsl(216deg, 78%, 94%)',
  mdsCoreColorBlueTint95: 'hsl(216deg, 78%, 97%)',
  mdsCoreColorBlueTint96: 'hsl(216deg, 28%, 96%)',
  mdsCoreColorBrandBlue: 'hsl(216.32deg, 100%, 22.35%)',
  mdsCoreColorBrandYellow: 'hsl(56deg, 100%, 50%)',
  mdsCoreColorGreenShade40: 'hsl(153deg, 50%, 28%)',
  mdsCoreColorGreenShade30: 'hsl(153deg, 50%, 34%)',
  mdsCoreColorGreenShade20: 'hsl(153deg, 58%, 38%)',
  mdsCoreColorGreenBase: 'hsl(153deg, 50%, 50%)',
  mdsCoreColorGreenTint30: 'hsl(153deg, 50%, 65%)',
  mdsCoreColorGreenTint40: 'hsl(153deg, 50%, 70%)',
  mdsCoreColorGreenTint80: 'hsl(153deg, 50%, 89%)',
  mdsCoreColorGrayBase: 'hsl(216deg, 100%, 10%)',
  mdsCoreColorGrayTint20: 'hsl(216deg, 28%, 28%)',
  mdsCoreColorGrayTint40: 'hsl(216deg, 12%, 46%)',
  mdsCoreColorGrayTint50: 'hsl(216deg, 12%, 55%)',
  mdsCoreColorGrayTint60: 'hsl(216deg, 12%, 64%)',
  mdsCoreColorGrayTint70: 'hsl(216deg, 11%, 73%)',
  mdsCoreColorGrayTint80: 'hsl(216deg, 11%, 82%)',
  mdsCoreColorGrayTint90: 'hsl(216deg, 9%, 91%)',
  mdsCoreColorGrayTint95: 'hsl(216deg, 8%, 95%)',
  mdsCoreColorGrayWhite: 'hsl(216deg, 100%, 100%)',
  mdsCoreColorYellowBase: 'hsl(56deg, 100%, 50%)',
  mdsCoreColorOrangeShade40: 'hsl(42deg, 100%, 29%)',
  mdsCoreColorOrangeBase: 'hsl(42deg, 100%, 49%)',
  mdsCoreColorOrangeTint80: 'hsl(42deg, 100%, 89%)',
  mdsCoreColorOrangeTint90: 'hsl(42deg, 100%, 95%)',
  mdsCoreColorRedShade20: 'hsl(8deg, 74%, 40%)',
  mdsCoreColorRedBase: 'hsl(8deg, 74%, 49%)',
  mdsCoreColorRedTint40: 'hsl(8deg, 74%, 69%)',
  mdsCoreColorRedTint80: 'hsl(8deg, 74%, 90%)',
  mdsCoreColorRedTint90: 'hsl(8deg, 74%, 95%)',
  mdsCoreColorPurpleBase: 'hsl(328deg, 100%, 30%)',
  mdsCoreColorPurpleTint90: 'hsl(328deg, 43%, 93%)',
  mdsCoreFontFamilyBase:
    'Lato, "Noto Sans", Helvetica, Roboto, Ubuntu, Arial, sans-serif',
  mdsCoreFontLeadingBase: '1rem',
  mdsCoreFontLeadingMedium: '1.25rem',
  mdsCoreFontLeadingXlarge: '1.5rem',
  mdsCoreFontLeadingXxlarge: '2.5rem',
  mdsCoreFontLeadingXxxlarge: '4rem',
  mdsCoreFontSizeXsmall: '0.75rem',
  mdsCoreFontSizeSmall: '0.875rem',
  mdsCoreFontSizeBase: '1rem',
  mdsCoreFontSizeMedium: '1.125rem',
  mdsCoreFontSizeLarge: '1.25rem',
  mdsCoreFontSizeXlarge: '1.5rem',
  mdsCoreFontSizeXxlarge: '2rem',
  mdsCoreFontWeightBase: '400',
  mdsCoreFontWeightBold: '700',
  mdsCoreOpacityTransparent: '0',
  mdsCoreOpacityBarely: '10%',
  mdsCoreOpacityTranslucent: '20%',
  mdsCoreOpacitySemi: '40%',
  mdsCoreOpacityFrosted: '60%',
  mdsCoreOpacityOpaque: '100%',
  mdsCoreScaleLayoutIncrement: '1px',
  mdsCoreScaleLayoutXxxsmall: '2px',
  mdsCoreScaleLayoutXxsmall: '4px',
  mdsCoreScaleLayoutXsmall: '8px',
  mdsCoreScaleLayoutSmall: '12px',
  mdsCoreScaleLayoutBase: '16px',
  mdsCoreScaleLayoutMedium: '20px',
  mdsCoreScaleLayoutLarge: '24px',
  mdsCoreScaleLayoutXlarge: '32px',
  mdsCoreScaleLayoutXxlarge: '48px',
  mdsCoreScaleTypographicXxsmall: '0.5rem',
  mdsCoreScaleTypographicXsmall: '0.75rem',
  mdsCoreScaleTypographicSmall: '0.875rem',
  mdsCoreScaleTypographicBase: '1rem',
  mdsCoreScaleTypographicMedium: '1.125rem',
  mdsCoreScaleTypographicLarge: '1.25rem',
  mdsCoreScaleTypographicXlarge: '1.5rem',
  mdsCoreScaleTypographicXxlarge: '2rem',
  mdsCoreScaleTypographicXxxlarge: '2.5rem',
  mdsCoreScaleTypographicXxxxlarge: '4rem',
  mdsCoreScaleTypographicXxxxxlarge: '5rem',
  mdsCoreShadowInnerShadow1: '0 1px 4px 0 hsla(216deg, 100%, 10%, 40%) inset',
  mdsCoreShadowInnerShadow2: '0 4px 8px 0 hsla(216deg, 100%, 10%, 40%) inset',
  mdsCoreShadowOuterShadow1: '0 1px 4px 0 hsla(216deg, 100%, 10%, 20%)',
  mdsCoreShadowOuterShadow2: '0 2px 8px 0 hsla(216deg, 100%, 10%, 20%)',
  mdsCoreShadowOuterShadow3: '0 4px 12px 0 hsla(216deg, 100%, 10%, 20%)',
  mdsCoreShadowOuterShadow4: '0 8px 32px 0 hsla(216deg, 100%, 10%, 20%)',
  mdsCoreTimingDurationFast: '0.15s',
  mdsCoreTimingDurationBase: '0.25s',
  mdsCoreTimingDurationSlow: '0.5s',
  mdsCoreTimingDurationXslow: '1s',
  mdsCoreTimingDurationXxslow: '2s',
  mdsCoreTimingFunctionBase: 'cubic-bezier(0.04, 0.2, 0.4, 1)',
  mdsCoreTimingFunctionNatural: 'cubic-bezier(0.4, 0, 0.5, 1)',
  mdsCoreTimingFunctionBounce: 'cubic-bezier(0.4, 0.06, 0.4, 1.4)',
  mdsCoreTimingDelayFast: '0.15s',
  mdsCoreTimingDelayBase: '0.25s',
  mdsCoreTimingDelaySlow: '0.5s',
  mdsCoreBackgroundPatternDisabled:
    'repeating-linear-gradient(45deg, hsl(216deg, 8%, 95%) 0, hsl(216deg, 8%, 95%) 0.40625rem, hsl(216deg, 9%, 91%) 0.40625rem, hsl(216deg, 9%, 91%) 0.5rem)',
};
